export const chartColorScheme = {
  domain: [
    "#8da7b0",
    "#f1cb8f",
    "#d6e098",
    "#7dc2ce",
    "#dfda8f",
    "#d0d9de",
    "#faead3",
    "#eef2d8",
    "#dbe8ec",
    "#f2f0d3",
    "#497c88",
    "#e7ad47",
    "#bcce4d",
    "#5fa6b5",
    "#ccc540",
  ],
};



// WEBPACK FOOTER //
// /agir/src/app/utils/chartColortScheme.ts